/* eslint-disable */
import { useRef, useState } from "react";

import { Typography } from "@mui/material";
import classNames from "classnames";

import { useMyCourseInstructor } from "../../hooks/useMyCourseInstructor";
import { FinishedSummaryItem } from "./FinishedSummaryItem";
import { LearningSummaryItem } from "./LearningSummaryItem";
import { UpcomingSummaryItem } from "./UpcomingSummaryItem";
import {
	FinishedSummaryDialog,
	TFinishedSummaryDialogRef,
} from "./FinishedSummaryDialog";
import {
	RequestMoneyDialog,
	TRequestMoneyDialogRef,
} from "./RequestMoneyDialog";

enum ETab {
	LEARNING = "learning",
	UPCOMING = "upcoming",
	FINISHED = "finished",
}

export function MyCourseStudents() {
	const { learningSummaries, upcomingSummaries, finishedSummaries } =
		useMyCourseInstructor();
	const [selectedTab, setSelectedTab] = useState<ETab>(ETab.LEARNING);
	const requestMoneyDialogRef = useRef<TRequestMoneyDialogRef | null>(null);
	const finishedSummaryRef = useRef<TFinishedSummaryDialogRef | null>(null);

	return (
		<div className="my-course-basic-info-container">
			<Typography className="small-title-text bold">Students</Typography>
			<div className="summary-tab-container item-separator-small">
				<div className="first-layer" />
				<div className={classNames("second-layer", { [selectedTab]: true })} />
				<div className="third-layer">
					<div
						className="tab-item"
						onClick={() => {
							setSelectedTab(ETab.LEARNING);
						}}>
						<Typography
							className={classNames("normal-text", {
								"bold white-text": selectedTab === ETab.LEARNING,
							})}>
							{`In-progress (${learningSummaries.length})`}
						</Typography>
					</div>
					<div
						className="tab-item"
						onClick={() => {
							setSelectedTab(ETab.UPCOMING);
						}}>
						<Typography
							className={classNames("normal-text", {
								"bold white-text": selectedTab === ETab.UPCOMING,
							})}>
							{`Upcoming (${upcomingSummaries.length})`}
						</Typography>
					</div>
					<div
						className="tab-item"
						onClick={() => {
							setSelectedTab(ETab.FINISHED);
						}}>
						<Typography
							className={classNames("normal-text", {
								"bold white-text": selectedTab === ETab.FINISHED,
							})}>
							{`Finished (${finishedSummaries.length})`}
						</Typography>
					</div>
				</div>
			</div>
			<div
				style={{ display: selectedTab === ETab.LEARNING ? "block" : "none" }}>
				{learningSummaries.map((learningSummary) => (
					<LearningSummaryItem
						learningSummary={learningSummary}
						requestMoneyDialogRef={requestMoneyDialogRef}
						key={learningSummary.id}
					/>
				))}
				{learningSummaries.length === 0 && (
					<Typography
						className="big-text item-separator-big"
						textAlign="center">
						It's time to prep!
					</Typography>
				)}
			</div>
			<div
				style={{ display: selectedTab === ETab.UPCOMING ? "block" : "none" }}>
				{upcomingSummaries.map((upcomingSummary) => (
					<UpcomingSummaryItem
						upcomingSummary={upcomingSummary}
						requestMoneyDialogRef={requestMoneyDialogRef}
						key={upcomingSummary.id}
					/>
				))}
				{upcomingSummaries.length === 0 && (
					<Typography
						className="big-text item-separator-big"
						textAlign="center">
						It's time to network!
					</Typography>
				)}
			</div>
			<div
				style={{ display: selectedTab === ETab.FINISHED ? "block" : "none" }}
				className="item-separator-big">
				<Typography className="big-text" textAlign="center">
					It's time to improve!
				</Typography>
				<div className="finished-summary-container item-separator-small">
					{finishedSummaries.map((finishedSummary) => (
						<FinishedSummaryItem
							finishedSummary={finishedSummary}
							finishedSummaryRef={finishedSummaryRef}
							key={finishedSummary.id}
						/>
					))}
				</div>
			</div>
			<RequestMoneyDialog ref={requestMoneyDialogRef} />
			<FinishedSummaryDialog
				ref={finishedSummaryRef}
				requestMoneyDialogRef={requestMoneyDialogRef}
			/>
		</div>
	);
}
